import { render, staticRenderFns } from "./SetTel.vue?vue&type=template&id=24bb7552&scoped=true&"
import script from "./SetTel.vue?vue&type=script&lang=js&"
export * from "./SetTel.vue?vue&type=script&lang=js&"
import style0 from "./SetTel.vue?vue&type=style&index=0&id=24bb7552&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb7552",
  null
  
)

export default component.exports